<template>

  <div class="canner">
    <Header class="Header"></Header>
    <div class="top-banner">
      <div class="bannerContent">
        <el-menu
          :default-active="path"
          class="el-menu-vertical-demo"
          background-color="#034f92"
          text-color="#fff"
          mode="horizontal"
          @select="menuSelect"
          active-text-color="#034f92"
          unique-opened
          router
        >
          <template v-for="(item, index) in nav_menu_data" v-if="index<=9" class="boldfont">
            <el-menu-item
              :index="item.path"
              :key="index"
              class="elMenuItem"
              style="text-align:center;"
              @click="menuClick(item.title)"
              >{{ item.title }}<el-divider direction="vertical" class="elMenuItemVertical" v-if="index != nav_menu_data.length-1"></el-divider></el-menu-item
            >
          </template>
        </el-menu>
      </div>
    </div>
    <div class="main">
      <div class="left" :style="{width: path != '/committee' ? '100%': '1200px'}">
        <transition :name="transitionName">
          <router-view :tabsTypeName="typeName" :tabsTypeId="typeId"></router-view>
        </transition>
      </div>
    </div>
    <Footer class="Footer"></Footer>

  </div>
</template>

<script>
import { hotType } from "@/api/main";

import Header from "@/components/committeeHeader.vue";
import Footer from "@/components/committeeFooter.vue";
export default {
  name: "Main",
  components: {
    Header,

    Footer,
  },
  data() {
    return {

      transitionName: "",
      userInfo: {},
      path: "/committee",
      typeName: '',
      typeId: '',
      nav_menu_data: [
        {
          title: "首页",
          path: "/committee",
        }
        // {
        //   title: "其他信息",
        //   path: "/Content?type=7"
        // }
      ],
    };
  },
  created() {
    this.getHotType()
    this.onRouteChanged();
  },
  methods: {
    getHotType(){
      var data = {
        deptId: 101
      }
      // if(this.$route.params.deptId){
      //   data = {
      //     deptId:this.$route.params.deptId
      //   }
      // }
      hotType(data).then(resp => {
        resp.data.map(el=>{
          var routerItem = {
            title: el.typeName,
            path: `/committee/Content?type=${el.typeName}&typeId=${el.id}`,
            id: el.id
          }
          if(el.typeName == '监理人才'){
            routerItem.path = null
          }
          this.nav_menu_data.push(routerItem)
        })
      });
    },
    menuSelect(path){
      if( path && path != '/committee'){
        var item = this.nav_menu_data.find(el=>path.split('=')[1].split('&')[0] == el.title)
        this.typeName = item.title
        this.typeId = item.id
      }
    },
    menuClick(name){
      if(name == '监理人才'){
        window.open('http://www.jdkjxy.com/jianliSearch', '_blank');
      } else {
        document.title = name == '首页' ? '中国铁道工程建设协会' : name
      }
    },
    onRouteChanged() {
      let that = this;
      that.path = that.$route.path;
      if(this.$route.query.type){
        this.path = this.path + `?type=${this.$route.query.type}&typeId=${this.$route.query.typeId}`
      }
    },
  },
  watch: {
    $route(to, from) {
      //如果to索引大于from索引,判断为前进状态,反之则为后退状态
      if (to.meta.index > from.meta.index) {
        //设置动画名称
        this.transitionName = "slide-left";
      } else {
        this.transitionName = "slide-right";
      }
      this.path = to.path;
      if(this.$route.query.type){
        this.path = this.path + `?type=${this.$route.query.type}&typeId=${this.$route.query.typeId}`
      }
    },
  },
};
</script>

<style scoped>
.canner {
  position: absolute;
  z-index: 1000;
  height: 100%;
  width: 100%;
  margin: 0 auto;
  overflow: auto;
}
.main {
  /* overflow-y: auto; */
  min-height: 700px;
   background: #fff;
  /* padding-bottom: 20px; */
}
.top-banner {
  width: 100%;
  height: 50px;
  padding: 2px 0;
  background: #034f92;
}
.bannerText{
  font-size: 18px;
  height: 54px;
  line-height: 54px;
  color: #ffcc0e;
  font-weight: bold;
  margin: 0 10px;
}
.bannerContent{
  width: 1200px;
  display: flex;
  margin: 0 auto;
}
.Footer {
  width: 100%;
  margin: 0 auto;
  height: 200px;
}
.left {
  overflow-x: hidden;
  /* width: 1200px; */
  margin: 0 auto;
  /* background: red; */
}
.left-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.left-title {
  color: #35567f;
  font-size: 20px;
  font-weight: bold;
  padding-bottom: 3px;
  padding: 0 15px;
  margin-left: 5px;
  border-bottom: 2px solid #298df8;
}
.right-img {
  width: 75px;
  margin: 30px 20px 20px;
  height: 75px;
  line-height: 75px;
  text-align: center;
  background: #fff;
  border-radius: 40px;
}
.right-img2 {
  width: 166px;
  height: 166px;
}
.tongdao {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.el-menu-item.is-active {
  background-color: #dd4012 !important;
  color: #fff !important;
  padding: 0 13px !important;
}
.el-menu.el-menu--horizontal{
  border-bottom: none;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none;
}
.el-menu--horizontal > .el-menu-item {
  height: 50px;
  padding: 0 10px !important;
  margin-right: 30px;
  line-height: 50px;
  font-weight: 900;
  font-size: 18px;
  border-bottom: none;
}
.elMenuItem{
  position: relative;
}
.elMenuItemVertical{
  position: absolute;
  top: 50%;
  margin-top: -8px;
  right: -23px;
}
.el-menu-item {
  text-align: center;
}
</style>
